@if (product) {
  <div class="product-details-quick" mat-dialog-close>
    <div class="popup-area-main" (click)="$event.stopPropagation()">
      <div class="product-details-quick-child">
        <div class="product-details-quick-child-left">
          <swiper
            [slidesPerView]="1"
            [spaceBetween]="0"
            [autoplay]="false"
            [loop]="true"
            [grabCursor]="true"
            [navigation]="true"
            [breakpoints]="{
              '0': {
                slidesPerView: 1,
              },
            }"
            class="mySwiper mySwiperTwo">
            @for (data of product.images; track data) {
              <ng-template swiperSlide>
                <div class="quick-child-left-img">
                  <img
                    [src]="data ? data : '/assets/images/png/fallbackImage.png'"
                    alt="image" />
                </div>
              </ng-template>
            }

            @if (!product.images) {
              <ng-template swiperSlide>
                <div class="quick-child-left-img">
                  <img
                    [src]="'/assets/images/png/fallbackImage.png'"
                    alt="image" />
                </div>
              </ng-template>
            }
          </swiper>
        </div>
        <!-- END! product-details-quick-child-left -->

        <div class="product-details-quick-child-right">
          <div class="quick-details-right-top">
            <div class="quick-right-title">
              <h2>
                <div (click)="selectTitle()">
                  {{ truncateAdvertName(product.name) }}
                </div>
                @if (product.user.isVerfied) {
                  <span class="verify-icon">
                    <img
                      src="./assets/images/svg/verified.svg"
                      alt="verified" />
                  </span>
                }
              </h2>

              <p>
                {{ product.division?.name
                }}{{
                  product.division?.name && product.area?.name ? ', ' : ''
                }}
                {{ product.area?.name
                }}{{ product.area?.name && product.zone?.name ? ', ' : '' }}
                {{ product.zone?.name }}
              </p>

              <!-- <div class="close-btn">
            <button type="button" mat-dialog-close>
              <i class="fa-regular fa-circle-xmark"></i>
            </button>
          </div> -->
              <!-- END! close-btn -->
            </div>

            <div class="quick-right-detail">
              <div class="phone-number">
                @if (product.phone) {
                  <a href="tel:{{ 'product.phone' }}">
                    <i class="fa-solid fa-phone"></i>
                    <span>{{ product.phone }}</span>
                  </a>
                }

                @if (product.phone) {
                  <a href="https://www.whatsapp.com/" target="_blank">
                    <i class="fa-brands fa-whatsapp"></i>
                    <span>{{ product.phone }}</span>
                  </a>
                }
              </div>
            </div>
          </div>

          <div class="quick-details-right-bottom">
            <h4>
              <i>About Me</i>
            </h4>
            <p class="description" [innerHTML]="product.shortDescription"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="product-details-quick" mat-dialog-close>
    <div class="popup-area-main" (click)="$event.stopPropagation()">
      <div class="product-details-quick-child" style="overflow: hidden">
        <div class="product-details-quick-child-left">
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{ minHeight: '20rem', height: '100%' }" />
        </div>
        <div class="product-details-quick-child-right">
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              height: '2rem',
              width: '16rem',
              background: 'gainsboro',
            }" />
          <br />
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{ height: '2rem', width: '8rem' }" />
          <br />
          <br />
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              height: '1rem',
              width: '4rem',
              background: 'gainsboro',
            }" />
          <br />
          <ngx-skeleton-loader count="5" appearance="line" />
        </div>
      </div>
    </div>
  </div>
}
